export var CARD_TYPES;
(function (CARD_TYPES) {
    CARD_TYPES["VISA"] = "visa";
    CARD_TYPES["MASTER_CARD"] = "master";
    CARD_TYPES["AMEX"] = "amex";
    CARD_TYPES["DISCOVER"] = "Discover";
    CARD_TYPES["HIPER"] = "hiper";
    CARD_TYPES["EURO_CARD"] = "Eurocard";
    CARD_TYPES["JCB"] = "jcb";
    CARD_TYPES["DINERS_CLUB"] = "diners";
    CARD_TYPES["AURA"] = "aura";
    CARD_TYPES["ELO"] = "elo";
    CARD_TYPES["MAESTRO"] = "maestro";
    CARD_TYPES["DAN"] = "dan";
    CARD_TYPES["UNION_PAY"] = "union_pay";
    CARD_TYPES["UNKNOWN"] = "unknown";
})(CARD_TYPES || (CARD_TYPES = {}));
